<template>
  <b-alert :show="anomalies.length > 0" variant="warning" class="mb-2">
    <div class="alert-heading d-flex align-items-center">
      <feather-icon icon="AlertTriangleIcon" class="mr-50" />
      <span>{{ anomalies.length }} client{{ anomalies.length === 1 ? '' : 's' }} needing attention</span>
    </div>

    <div class="alert-body">
      <div
        v-for="anomaly in anomalies"
        :key="anomaly.client_id || anomaly.client_key"
        class="d-flex justify-content-between align-items-center py-50 border-bottom-light"
      >
        <div>
          <component
            :is="anomaly.client_id ? 'router-link' : 'span'"
            v-bind="anomaly.client_id ? { to: { name: 'api-clients-usage-view', params: { id: anomaly.client_id } } } : {}"
            class="font-weight-bold"
          >
            {{ anomaly.title || anomaly.client_key || 'Unattributed traffic' }}
          </component>
          <div class="small">{{ anomaly.reasons.join(' · ') }}</div>
        </div>

        <div class="text-right small text-muted">
          {{ formatCount(anomaly.requests) }} calls
        </div>
      </div>

      <div class="small text-muted mt-50">
        Unattributed rows are requests whose credentials never resolved to a client — a
        run of them usually means a partner is holding a stale or mistyped secret.
      </div>
    </div>
  </b-alert>
</template>

<script>
import { BAlert } from 'bootstrap-vue'
import { formatCount } from './usageFormat'

export default {
  name: 'UsageAnomalies',
  components: {
    BAlert,
  },
  props: {
    anomalies: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    formatCount,
  },
}
</script>

<style scoped>
.border-bottom-light:not(:last-of-type) {
  border-bottom: 1px solid rgba(34, 41, 47, 0.08);
}
</style>
